"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    translation: {
        cart: {
            general: {
                close: 'Close',
                empty: 'Oopsie Poopsie, Your Bag is Empty!',
                remove: 'Remove',
                title: 'Your Bag',
            },
        },
    },
};
